import { render, staticRenderFns } from "./BsNotification.vue?vue&type=template&id=7e082661&"
import script from "./BsNotification.vue?vue&type=script&lang=js&"
export * from "./BsNotification.vue?vue&type=script&lang=js&"
import style0 from "./BsNotification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports